export const CreateBlogPost = body => {
    return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v2/blogs/create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(res => {
        return res.json();
      })
      .catch(e => console.log(`error at Create blog ${e}`));
  };

  export const UpdateBlogPost = (id,body) => {
    return fetch(
      `${process.env.REACT_APP_DATABASEURL}/api/v2/blogs/update/${id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    )
      .then(res => {
        return res.json();
      })
      .catch(e => console.log(`error at update blog ${e}`));
  };

  export const getAllBlogsList = () => {
    return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v2/blogs/admin/get`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then(res => {
        return res.json();
      })
      .catch(e => console.log(`error at getting blogs list ${e}`));
  };

  export const deleteBlog = id => {
    return fetch(
      `${process.env.REACT_APP_DATABASEURL}/api/v2/blogs/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`
        },
      }
    )
      .then(res => {
        return res.json();
      })
      .catch(e => console.log(`error at deleting blog ${e}`));
  };